import { MutationTree } from "vuex";
import { StatisticsScreenState } from "@/modules/statistics/store/state";
import { log } from "@/core/logger";

export enum StatisticsMutations {
  SET_STATISTICS = "SET_STATISTICS",
  SET_ERROR = "SET_ERROR",
  SET_LOADING = "SET_LOADING",
  SET_NOT_LOADING = "SET_NOT_LOADING",
}

const mutations: MutationTree<StatisticsScreenState> = {
  [StatisticsMutations.SET_STATISTICS](
    state: StatisticsScreenState,
    payload: { items: any }
  ): void {
    log(`setting statistics`);
    state.items = payload.items;
  },

  [StatisticsMutations.SET_ERROR](state: StatisticsScreenState, payload: { error: string }): void {
    log(`setting error:`, payload?.error);
    state.error.message = payload?.error;
  },

  [StatisticsMutations.SET_LOADING](state: StatisticsScreenState): void {
    log(`setting loading to true`);
    state.isLoading = true;
  },

  [StatisticsMutations.SET_NOT_LOADING](state: StatisticsScreenState): void {
    log(`setting loading to false`);
    state.isLoading = false;
  },
};

export default mutations;
